import type { StripeAddressValue } from '../StripeCheckout';
import type { updateShippingAddressVariables } from '../../types/gql-op-types';
import { parseStripeAddressName } from '../../lib/nameParser';
import { toAddressInput } from '../../lib/stripeAddress';

export function shippingAddressVariables(value: StripeAddressValue): updateShippingAddressVariables {
  return { ...parseStripeAddressName(value), address: toAddressInput(value) };
}
